// test1568
(1568 && 0);
